import { SetStateAction, useCallback } from 'react'
import { ShippingServiceExtended } from '../..'
import RangeTable, { RangeTableDataDict } from '../../../../../../../../../../baseComponents/RangeTable'
import { getCurrencySymbol } from '../../../../../../../../../../utils/globals/price'


interface TableShippingRatesCostProps extends TableShippingRatesCostLogicProps {
    dataService: ShippingServiceExtended
    setDataService: React.Dispatch<SetStateAction<ShippingServiceExtended | null>>
    EditComponent: React.ElementType
    editComponentProps: any
}

const TableShippingRatesCost: React.FC<TableShippingRatesCostProps> = ({ dataService, setDataService, EditComponent, editComponentProps }) => {
    const { onChangeRanges, onChangeRangeRow } = useTableShippingRatesCostLogic({ setDataService })
    const { rangesCost, CurrencyId } = dataService
    return (
        <RangeTable tags={{ header: 'kg', rows: getCurrencySymbol(CurrencyId) }} rangeData={dataService.dictShippingRateCosts} ranges={rangesCost} {...{ onChangeRanges, onChangeRangeRow, EditComponent, editComponentProps }} />
    )
}
interface TableShippingRatesCostLogicProps {
    setDataService: React.Dispatch<SetStateAction<ShippingServiceExtended | null>>
}

const useTableShippingRatesCostLogic = ({ setDataService }: TableShippingRatesCostLogicProps) => {

    const onChangeRanges = useCallback((rangesCost: number[]) => {
        setDataService((old) => {
            if (old) {
                return { ...old, rangesCost }
            }
            return null
        })
    }, [setDataService])

    const onChangeRangeRow = useCallback((rangeData: RangeTableDataDict) => {
        setDataService((old) => {
            if (old) {
                return { ...old, 'dictShippingRateCosts': rangeData }
            }
            return null
        })

    }, [setDataService])

    return { onChangeRanges, onChangeRangeRow }
}

export default TableShippingRatesCost